<div id="BodyPane">
    <div class="row border rounded p-2 ms-1 me-1 mb-2">
        <form role="form">
            <div class="row row-cols-lg-auto g-2 align-items-center">
                <label class="col-form-label-sm">Loc:</label>
                <div class="col-12">
                    <select name="locCode" #locCodeDropdown="ngModel" class="form-select form-select-sm select-m" (change)="parameterOnChange()" [(ngModel)]="loadBankGenerator.loadBankParameters.locCode">
                        <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
                    </select>
                </div>
                <label class="col-form-label-sm">Type:</label>
                <div class="col-12">
                    <select name="loadBankType" class="form-select form-select-sm" [(ngModel)]="loadBankGenerator.loadBankParameters.loadBankType">
                        <option [ngValue]="0">Load</option>
                        <option [ngValue]="1">Unload</option>
                    </select>
                </div>
                <button class="btn btn-sm btn-primary ms-2" (click)="refreshButtonClick()">Refresh</button>
            </div>
            <div class="row">
                <div class="col d-inline-flex">
                    <div style="font-size: small" class="mt-1 pt-1">
                        <button type="button" style="background-color: transparent; border: none; color: blue; cursor: pointer;" (click)="toggleLoadBankGenerator()">Load Generator</button>
                    </div>
                    <div class="mt-2">
                        <i class="fa-solid fa-caret-up icon" *ngIf="!showLoadGenerator" style="color: blue;"></i>
                        <i class="fa-solid fa-caret-down icon" *ngIf="showLoadGenerator" style="color: blue;"></i>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <toast-notification #toastNotification></toast-notification>
    <div [ngClass]="{'hidden': !showLoadGenerator}" class="container-fluid">
        <div class="row border rounded">
            <div class="col-3">
                <div>Load Generator</div>
                <div class="row">
                    <div class="col-3">
                        <label class="form-label">Quantity:</label>
                        <input class="form-control form-control-sm" type="number" [(ngModel)]="loadBankGenerator.quantityBuilder" [ngModelOptions]="{standalone: true}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-2 pe-1">
                        <label class="form-label">Prefix:</label>
                        <input class="form-control form-control-sm" [(ngModel)]="loadBankGenerator.prefixBuilder" [ngModelOptions]="{standalone: true}" />
                    </div>
                    <div class="col-3 ps-1 pe-1">
                        <label class="form-label">Number:</label>
                        <input class="form-control form-control-sm" mask="9*" [(ngModel)]="loadBankGenerator.numberBuilder" [ngModelOptions]="{standalone: true}" />
                    </div>
                    <div class="col-2 ps-1">
                        <label class="form-label">Suffix:</label>
                        <input class="form-control form-control-sm" [(ngModel)]="loadBankGenerator.suffixBuilder" [ngModelOptions]="{standalone: true}" />
                    </div>
                    <div class="col-1 ps-0 pb-2" style="display: flex; align-items: end">
                        <i class="fa-solid fa-rotate-right icon" (click)="clearLoadBankGenerator()"></i>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 pt-2 d-flex align-items-end justify-content-end">
                        <button class="btn btn-sm btn-primary" [disabled]="loadBankGenerator.quantityBuilder == null || loadBankGenerator.quantityBuilder == 0 || loadBankGenerator.numberBuilder.length == 0" (click)="concatenateLoadBuilder()">
                            Generate
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-1">
                <div>Load Editor</div>
                <div class="row pb-2">
                    <div class="col">
                        <textarea #loadEditor class="form-control form-control-sm" style="width: inherit; height: 235px;" placeholder="Copy here" (paste)="onPaste($event)" [(ngModel)]="loadTemplateNumbers" [ngModelOptions]="{standalone: true}"></textarea>
                    </div>
                </div>
            </div>
            <div class="col-5">
                <div>Additional Info</div>
                <div class="row">
                    <div class="col-5">
                        <label class="form-label">Description</label>
                        <input class="form-control form-control-sm" [(ngModel)]="loadBankGenerator.description" [ngModelOptions]="{standalone: true}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <label class="form-label">Commodity:</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <select id="commodity" name="commodity" class="form-select form-select-sm" (change)="commodityOnChange()" [(ngModel)]="loadBankGenerator.commodityCode">
                            <option value=""></option>
                            <option *ngFor="let item of commodityList" value="{{item.value}}">{{item.text}}</option>
                        </select>
                    </div>
                    <div class="col-auto px-1 d-flex align-items-center">
                        <i class="fa-solid fa-x icon" (click)="resetCommodity()"></i>
                    </div>
                    <div class="col-2 px-1 d-flex align-items-center" style="min-width: 100px">
                        <input type="text" id="commodityCode" class="form-control form-control-sm" placeholder="Commodity" disabled value="{{loadBankGenerator.commodityCode}}" />
                    </div>             
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-check float-start">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" (click)="resetLocation()" [(ngModel)]="locationSearchAll" [ngModelOptions]="{standalone: true}" />
                            <label class="form-check-labe form-label" for="flexCheckDefault">
                                Search all {{locationType}}s
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Locations -->
                <div class="row mt-1 g-1 align-items-center">
                    <div #locationDropdown class="col-auto">
                        <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" (click)="toggleLocationSearch()" [disabled]="loadBankGenerator.commodityCode.length == 0 && locationSearchAll == false">
                            {{locationType}}
                        </button>
                        <div class="dropdown-menu show" *ngIf="showLocationSearch">
                            <div class="px-2" style="max-height: 300px;">
                                <div class="location-search-lg table-responsive" *ngIf="!locationSearchAll">
                                    <table class="table table-sm table-borderless table-hover">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Customer
                                                    <input type="text" class="form-control form-control-sm" id="locationSearchCustomer" name="locationSearchCustomer" [(ngModel)]="locationSearchCustomer" />
                                                </th>
                                                <th>
                                                    {{locationType}}
                                                    <input type="text" class="form-control form-control-sm" id="locationSearchName" name="locationSearchName" [(ngModel)]="locationSearchName" />
                                                </th>
                                                <th>
                                                    City
                                                    <input type="text" class="form-control form-control-sm" id="locationSearchCity" name="locationSearchCity" [(ngModel)]="locationSearchCity" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of filteredLocations" (click)="selectLocation(item)">
                                                <td>{{item.customerName}}</td>
                                                <td>{{item.locationName}}</td>
                                                <td>{{item.city}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="location-search px-1 table-responsive" *ngIf="locationSearchAll">
                                    <table class="table table-sm table-borderless table-hover">
                                        <thead>
                                            <tr [formGroup]="locationSearchForm">
                                                <th>
                                                    {{locationType}}
                                                    <input type="text" class="form-control form-control-sm" formControlName="locationName" />
                                                </th>
                                                <th>
                                                    City
                                                    <input type="text" class="form-control form-control-sm" formControlName="city" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of locationList" (click)="selectLocation(item)">
                                                <td>{{item.locationName}}</td>
                                                <td>{{item.city}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-auto px-1 align-items-center">
                        <i class="fa-solid fa-x icon" (click)="resetLocation()"></i>
                    </div>
                    <div class="col d-flex align-items-center" *ngIf="!locationSearchAll">
                        <input type="text" id="customerName" class="form-control form-control-sm" placeholder="Customer" [title]="loadBankGenerator.customerName" disabled value="{{loadBankGenerator.customerName}}" />
                    </div>
                    <div class="col d-flex align-items-center" *ngIf="locationSearchAll">
                        <input type="text" id="locationType" class="form-control form-control-sm" placeholder="{{locationType}}" [title]="loadBankGenerator.locationName" disabled value="{{loadBankGenerator.locationName}}" />
                    </div>
                    <div class="col d-flex align-items-center">
                        <input type="text" id="locationCity" class="form-control form-control-sm" placeholder="City" [title]="loadBankGenerator.locationCity" disabled value="{{loadBankGenerator.locationCity}}" />
                    </div>
                </div>

                <!--Contracts-->
                <div class="row mt-1 g-1 align-items-center">
                    <div #contractDropdown class="col-auto">                     
                        <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" (click)="toggleContractSearch()" [disabled]="loadBankGenerator.locationId == 0">
                            Contract
                        </button>
                        <div class="dropdown-menu show" *ngIf="showContractSearch">
                            <div class="contract-select-list px-2" style="max-height: 350px">
                                <table class="table table-sm table-borderless table-hover">
                                    <thead>
                                        <tr>
                                            <th>Contract #</th>
                                            <th>Begin Date</th>
                                            <th>End Date</th>
                                            <th class="text-center">Qty</th>
                                            <th class="text-center">Open</th>
                                            <th class="text-center">Loads</th>
                                            <th class="text-center">Open</th>
                                            <th>Cust Contract</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let contract of contractList" (click)="selectContract(contract)">
                                            <td>{{contract.contractNumber}}</td>
                                            <td>{{contract.periodBeginDate}}</td>
                                            <td>{{contract.periodEndDate}}</td>
                                            <td class="text-end">{{contract.quantity}}</td>
                                            <td class="text-end">{{contract.openQuantity}}</td>
                                            <td class="text-end">{{contract.loads}}</td>
                                            <td class="text-end">{{contract.openLoads}}</td>
                                            <td>{{contract.customerContract}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>                        
                    </div>
                    <div class="col-auto px-1 d-flex align-items-center">
                        <i class="fa-solid fa-x icon" (click)="clearContract()"></i>
                    </div>
                    <div class="col d-flex align-items-center">
                        <input type="text" id="contractNumber" class="form-control form-control-sm" placeholder="Contract" disabled value="{{loadBankGenerator.contractNumber}}" />
                    </div>
                    <!-- If locationType == 'Origin' -->
                    <div class="col d-flex align-items-center" *ngIf="locationType == 'Origin'">
                        <input type="text" id="shipFrom" class="form-control form-control-sm" placeholder="Ship From" [title]="loadBankGenerator.shipFrom" disabled value="{{loadBankGenerator.shipFrom}}" />
                    </div>
                    <div class="col d-flex align-items-center" *ngIf="locationType == 'Origin'">
                        <input type="text" id="shipTo" class="form-control form-control-sm" placeholder="Ship To" [title]="loadBankGenerator.shipTo" disabled value="{{loadBankGenerator.shipTo}}" />
                    </div>
                    <!-- If locationType == 'Destination' -->
                    <div class="col d-flex align-items-center" *ngIf="locationType == 'Destination'">
                        <input type="text" id="shipTo" class="form-control form-control-sm" placeholder="Ship To" [title]="loadBankGenerator.shipTo" disabled value="{{loadBankGenerator.shipTo}}" />
                    </div>
                    <div class="col d-flex align-items-center" *ngIf="locationType == 'Destination'">
                        <input type="text" id="shipFrom" class="form-control form-control-sm" placeholder="Ship From" [title]="loadBankGenerator.shipFrom" disabled value="{{loadBankGenerator.shipFrom}}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md pt-2 pb-2 d-flex align-items-end justify-content-end">
                        <button *ngIf="!showSpinnerAddButton" class="btn btn-sm btn-primary" (click)="saveLoadBankGenerator()" [disabled]="loadTemplateNumbers == ''">Add</button>
                        <button *ngIf="showSpinnerAddButton" class="btn btn-sm btn-danger me-2" disabled>
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            <span>Adding...</span>
                        </button>
                    </div>
                </div>
                <div *ngIf="showDupsError" class="row">
                    <div class="container-fluid">
                        <ul class="text-danger">
                            <li *ngIf="showDupsError">Please remove duplicates from generator and try again</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row ps-1 g-2" style="height: 41px;">
        <div class="col-auto">
            <button *ngIf="showDeleteButton && !showSpinnerDeleteButton" class="btn btn-sm btn-primary" (click)="deleteSelectedLoadBankRecords()"> Delete</button>
            <button *ngIf="showSpinnerDeleteButton" class="btn btn-sm btn-danger me-2" disabled>
                <span class="spinner-border spinner-border-sm me-1"></span>
                <span>Deleting...</span>
            </button>
        </div>
        <div class="col-auto px-1">
            <label *ngIf="showDeleteButton" class="form-label">Selected: {{isSelectedCount}}</label>
        </div>
        <div class="col pe-3 d-flex align-items-center justify-content-end">
            <label class="form-label">Total: {{totalRecordCount}}</label>
        </div>
    </div>

    <div class="m-1">
        <div>
            <pqgrid #loadBankGrid [options]="loadBankOptions"></pqgrid>
        </div>
    </div>
</div>

